@if (internalUserAccess || externalUserAccess) {
  <p-tabs [lazy]="true" [(value)]="activeTab" (valueChange)="onTabChange($event)">
    <p-tablist>
      @if (externalUserAccess) {
        <p-tab value="external">External Users</p-tab>
      }
      @if (internalUserAccess) {
        <p-tab value="internal">Internal Users</p-tab>
      }
    </p-tablist>
    <p-tabpanels>
    @if (externalUserAccess && initExternal) { 
      <p-tabpanel value="external">
        <app-external-users-list />
      </p-tabpanel>
    }

    @if (internalUserAccess && initInternal) { 
      <p-tabpanel value="internal">
        <app-internal-users-list />
      </p-tabpanel>
    }
    </p-tabpanels>
  </p-tabs>
}

@if (!internalUserAccess && !externalUserAccess) {
  <p-panel
    header="Unauthorized"
    toggler="header"
    [showHeader]="true"
    [toggleable]="false"
    styleClass="unauthorized-message">
    <p>
      You do not have access to view this page. Please contact an administrator to review your access.
    </p>
  </p-panel>
}

<p-toast styleClass="toast-text-wrap" position="bottom-left"></p-toast>

<p-confirmDialog header="Confirmation"
  appendTo="body"
  [rejectIcon]="''"
  [acceptIcon]="''"
  [rejectButtonStyleClass]="'p-button-secondary'">
</p-confirmDialog>
